import * as yup from 'yup';

export const orderConfirmAddresSchema = yup.object().shape({
  country: yup.string().min(2, 'Минимум 2 символа').max(100, 'Максимум 100 символов').required('Введите страну'),
  region: yup.string().min(2, 'Минимум 2 символа').max(100, 'Максимум 100 символов').required('Введите регион'),
  city: yup.string().min(2, 'Минимум 2 символа').max(100, 'Максимум 100 символов').required('Введите город'),
  street: yup.string().min(2, 'Минимум 2 символа').max(150, 'Максимум 150 символов').required('Введите улицу'),
  house: yup.string().min(1, 'Минимум 1 символ').max(50, 'Максимум 50 символов').required('Введите номер дома'),
  apartment: yup.string().min(1, 'Минимум 1 символ').max(50, 'Максимум 50 символов').required('Введите номер квартиры'),
  // Индекс необязательный и без жёсткой проверки формата: для КЗ
  // он бывает буквенно-цифровым, у части записей в 1С его вовсе нет —
  // не блокируем оформление заказа из-за этого поля.
  postcode: yup.string().max(20, 'Максимум 20 символов'),
});
